import { getConfig } from '../AppConfig';

// Validation is independent of current hours, menus and the clock. Constructing
// Intl formatters repeatedly during slot generation is expensive on mobile.
const validity = new Map();
export const isValidTimezone = (timezone) => {
  if (typeof timezone !== 'string' || !timezone.trim()) return false;
  if (validity.has(timezone)) return validity.get(timezone);
  let valid;
  try {
    Intl.DateTimeFormat('en-US', { timeZone: timezone });
    valid = true;
  } catch (error) {
    valid = false;
  }
  if (validity.size >= 32) validity.delete(validity.keys().next().value);
  validity.set(timezone, valid);
  return valid;
};

// Prefer the restaurant's clock for fulfillment labels, then the business clock.
export const getBusinessTimezone = (restaurantTimezone) => {
  if (isValidTimezone(restaurantTimezone)) return restaurantTimezone;
  const configuredTimezone = getConfig()?.timezone;
  return isValidTimezone(configuredTimezone) ? configuredTimezone : 'UTC';
};
